import { MappedEntity } from '@toggle/toggle';
import { globalPriceFormatter } from '~/utils/asset-price/assetPrice';
import { PriceStatus } from '@toggle/helpers';
import styles from './CatalystSingleMarketReactionPrice.module.scss';

export const priceStatusClassMap: Record<PriceStatus, string> = {
  [PriceStatus.Default]: styles.default,
  [PriceStatus.Negative]: styles.negative,
  [PriceStatus.Positive]: styles.positive,
};

export const formatPrice = (price: number, entity: MappedEntity) =>
  globalPriceFormatter({
    entity,
    price,
    priceSuffix: '',
    shouldShowCurrency: false,
  });
